import { render, staticRenderFns } from "./insertAttributes.vue?vue&type=template&id=bb3c14f0"
import script from "./insertAttributes.vue?vue&type=script&lang=js"
export * from "./insertAttributes.vue?vue&type=script&lang=js"
import style0 from "./insertAttributes.vue?vue&type=style&index=0&id=bb3c14f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports